export { useShallowSelector } from '../../../../hooks';

export const forgivenessStandardMessagingSelector = (state) => ({
  advancesById: state.entities.advances.byId,
  loanForgiveness: state.entities.loanForgiveness,
  portalRedesignEnabled: state.config.portalRedesignEnabled,
});
